import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/nyla/Navbar";
import { Footer } from "@/components/nyla/Footer";

export const Layout = () => (
  <main className="bg-[#F5F5F7] text-[#1D1D1F] font-body">
    <Navbar />
    <Outlet />
    <Footer />
  </main>
);
